<template>
    <div class="about">
        <h1>Phrospr app</h1>
        <p>
            This is a planningtool that was build to schedule and complete appointments. From maintenances till lead
            visits, ...
        </p>
        <p>It will be used by it's technicians to preform and register their day to day tasks.</p>
        <p>If you have issues with the app please contact your representative and explain the problem.</p>
        <p>We will proivde a solution as fast as possible!</p>
        <p>The Phrospr Team</p>
    </div>
</template>

<script lang="ts">
export default {
    name: 'about',
};
</script>
